function a(t) {
  return t !== t;
}
export {
  a as default
};
